"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentWrapper = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _exampleIndex = _interopRequireDefault(require("./example-index.js"));

var _classnames = _interopRequireDefault(require("classnames"));

var _onThisPage = _interopRequireDefault(require("../../on-this-page/on-this-page"));

var _feedback = _interopRequireDefault(require("../../feedback/feedback"));

var _overviewHeader = _interopRequireDefault(require("../../overview-header/overview-header"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Content = /*#__PURE__*/function (_React$Component) {
  _inherits(Content, _React$Component);

  var _super = _createSuper(Content);

  function Content() {
    _classCallCheck(this, Content);

    return _super.apply(this, arguments);
  }

  _createClass(Content, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          layoutConfig = _this$props.layoutConfig,
          filters = _this$props.filters,
          parentPath = _this$props.parentPath,
          frontMatter = _this$props.frontMatter,
          AppropriateImage = _this$props.AppropriateImage;
      var showCards = layoutConfig.showCards; // if showCards is true, use the ExampleIndex component
      // else use the default content wrapper to display the content

      return showCards ? /*#__PURE__*/_react.default.createElement(_exampleIndex.default, _extends({}, this.props, {
        filters: filters[parentPath],
        frontMatter: frontMatter,
        sectionPath: parentPath,
        AppropriateImage: AppropriateImage
      }), children) : /*#__PURE__*/_react.default.createElement(ContentWrapper, this.props, children);
    }
  }]);

  return Content;
}(_react.default.Component);

exports.default = Content;
Content.propTypes = {
  children: _propTypes.default.node,
  frontMatter: _propTypes.default.object.isRequired,
  parentPath: _propTypes.default.string,
  filters: _propTypes.default.object,
  AppropriateImage: _propTypes.default.func,
  layoutConfig: _propTypes.default.shape({
    showCards: _propTypes.default.bool
  })
};

var ContentWrapper = /*#__PURE__*/function (_React$Component2) {
  _inherits(ContentWrapper, _React$Component2);

  var _super2 = _createSuper(ContentWrapper);

  function ContentWrapper() {
    var _this;

    _classCallCheck(this, ContentWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderFeedback", function () {
      var _this$props2 = _this.props,
          location = _this$props2.location,
          section = _this$props2.section,
          layoutConfig = _this$props2.layoutConfig;
      var layout = layoutConfig.layout;
      var _this$props$constants = _this.props.constants,
          SITE = _this$props$constants.SITE,
          FORWARD_EVENT_WEBHOOK = _this$props$constants.FORWARD_EVENT_WEBHOOK;
      return /*#__PURE__*/_react.default.createElement(_feedback.default, _extends({}, _this.props, {
        type: layout === 'example' ? 'example' : undefined,
        site: SITE,
        location: location,
        section: section,
        webhook: FORWARD_EVENT_WEBHOOK
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderAside", function (showFeedback) {
      var _this$props3 = _this.props,
          frontMatter = _this$props3.frontMatter,
          layoutConfig = _this$props3.layoutConfig;
      var onThisPage = frontMatter.onThisPage;
      var headings = frontMatter.headings || _this.props.headings;
      var showOnThisPage = onThisPage ? onThisPage : layoutConfig.onThisPage;
      var showToc = headings && headings.length > 0 && showOnThisPage;
      return /*#__PURE__*/_react.default.createElement("aside", {
        "data-swiftype-index": "false",
        className: "scroll-auto-mxl scroll-styled viewport-almost-mxl sticky-mxl",
        style: {
          top: '10px'
        }
      }, _this.props.customAside ? _this.props.customAside : undefined, showToc && headings && headings.length > 0 && /*#__PURE__*/_react.default.createElement(_onThisPage.default, {
        headings: headings,
        themeWrapper: "mb36-mxl mb18"
      }), showFeedback && /*#__PURE__*/_react.default.createElement("div", {
        className: "none block-mxl"
      }, _this.renderFeedback()));
    });

    return _this;
  }

  _createClass(ContentWrapper, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          frontMatter = _this$props4.frontMatter,
          layoutConfig = _this$props4.layoutConfig;
      var title = frontMatter.title,
          unProse = frontMatter.unProse,
          hideFeedback = frontMatter.hideFeedback,
          layout = frontMatter.layout,
          overviewHeader = frontMatter.overviewHeader;
      var hideTitle = layoutConfig.hideTitle; // check frontmatter then default to layout config

      var showFeedback = hideFeedback ? !hideFeedback : !layoutConfig.hideFeedback; // do not show h1 if `hideTitle: true` or `overviewHeader` is enabled

      var showTitle = !hideTitle && !overviewHeader;
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "docs-content"
      }, showTitle && /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('col prose', {
          'col--8-mxl col--12': layoutConfig.aside !== 'none'
        })
      }, /*#__PURE__*/_react.default.createElement("h1", {
        className: "txt-fancy"
      }, title)), overviewHeader && /*#__PURE__*/_react.default.createElement(_overviewHeader.default, overviewHeader), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid grid--gut60"
      }, (layoutConfig.aside !== 'none' || this.props.customAside) && /*#__PURE__*/_react.default.createElement("div", {
        className: "dr-ui--page-layout-aside col col--12 col--4-mxl"
      }, this.renderAside(showFeedback)), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('col', {
          'col--8-mxl col--12': layoutConfig.aside !== 'none',
          prose: unProse !== true
        })
      }, children, showFeedback && /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('my36', {
          'block none-mxl': layout !== 'full' // hide feedback at bottom of page on larger screens unless layout is full (always show it on the bottom)

        })
      }, this.renderFeedback()))));
    }
  }]);

  return ContentWrapper;
}(_react.default.Component);

exports.ContentWrapper = ContentWrapper;
ContentWrapper.propTypes = {
  children: _propTypes.default.node,
  frontMatter: _propTypes.default.shape({
    title: _propTypes.default.string.isRequired,
    unProse: _propTypes.default.bool,
    hideFeedback: _propTypes.default.bool,
    headings: _propTypes.default.array,
    layout: _propTypes.default.string,
    overviewHeader: _propTypes.default.object,
    onThisPage: _propTypes.default.bool
  }).isRequired,
  headings: _propTypes.default.array,
  location: _propTypes.default.object.isRequired,
  parentPath: _propTypes.default.string,
  filters: _propTypes.default.object,
  AppropriateImage: _propTypes.default.func,
  section: _propTypes.default.string,
  constants: _propTypes.default.shape({
    SITE: _propTypes.default.string.isRequired,
    BASEURL: _propTypes.default.string.isRequired,
    FORWARD_EVENT_WEBHOOK: _propTypes.default.shape({
      production: _propTypes.default.string.isRequired,
      staging: _propTypes.default.string.isRequired
    }).isRequired
  }).isRequired,
  layoutConfig: _propTypes.default.shape({
    layout: _propTypes.default.string,
    hideTitle: _propTypes.default.bool,
    showCards: _propTypes.default.bool,
    hideFeedback: _propTypes.default.bool,
    aside: _propTypes.default.string,
    onThisPage: _propTypes.default.bool
  }),
  navigation: _propTypes.default.shape({
    hierarchy: _propTypes.default.object
  }),
  customAside: _propTypes.default.node
};